/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";
import settings from "./appSettings";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export function msalConfig(tenant, baseUrl) {
  return {
    auth: {
      clientId: settings.clientId,
      authority: `https://login.microsoftonline.com/${tenant}`,
      redirectUri: baseUrl || "http://localhost:3000/",
      // knownAuthorities: ["company-name.b2clogin.com"],
      postLogoutRedirectUri: baseUrl || "http://localhost:3000",
      navigateToLoginRequestUrl: true,
    },
    cache: {
      cacheLocation: "localStorage", // This configures where your cache will be stored
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
      loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
          // Always check PII flag first, regardless of log level
          // This prevents accidentally logging sensitive data
          if (containsPii) {
            return;
          }
          switch (level) {
            case LogLevel.Error:
              console.error("[MSAL]", message);
              return;
            case LogLevel.Warning:
              console.warn("[MSAL]", message);
              return;
            case LogLevel.Info:
              console.info("[MSAL]", message);
              return;
            case LogLevel.Verbose:
              console.debug("[MSAL]", message);
              return;
            default:
              return;
          }
        },
        // Only log warnings and errors in production
        logLevel: LogLevel.Warning,
      },
    },
  };
}

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: settings.graphUserScopes,
};
